import http from '../http/http';

import { EMAIL_EXISTS, generateEndpoint } from '../http/endpoints';

export default (() => {
    const getEmailExists = (email) =>
        http.get(generateEndpoint(EMAIL_EXISTS, { email }));

    return {
        getEmailExists,
    };
})();
